import { getReportType, isConfigReport, isRelationalReport, isMultiAccountReport } from 'reporting-data/tsTypes/reportTypes';
import { getReportDataTypesForTracking, getOrigin
//@ts-expect-error Untyped import
} from 'reporting-action-components/lib/report-logic';
import { getReportDashboardId, getReportDashboardInfo, getReportId, getTemplateKey, getPluginName, getCustomWidgetType, getReportChartType } from 'reporting-data/report/reportGetters';
import { getDimensions, getFiltersFromConfigReport, getMetrics } from 'reporting-data/report/configReportGetters';
import { getDimensionsFromRelationalReport, getFilteringFromRelationalReport, getMetricPropertyAndAggregationFromRelationalReport } from 'reporting-data/report/relationalReportGetters';
import { getUsageTracker } from '../monitoring/usageTracker';
import { EVENTS } from './events';
import { DRILLDOWN_ACTION } from '../constants/trackingConstants';
//@ts-expect-error Untyped import
import { stableStringify } from 'reporting-data/lib/stringify';
const getReportAndDashboardIds = report => {
  const dashboardReportIds = getReportDashboardInfo(report).map(info => info.get('id')).toJS();
  return {
    dashboardId: getReportDashboardId(report),
    dashboardReportIds: dashboardReportIds.length > 0 ? dashboardReportIds : undefined,
    reportId: getReportId(report)
  };
};
const getReportContainerDimensions = reportId => {
  const dashboardWidget = document.getElementById(reportId.toString());
  if (!dashboardWidget) return {};
  const reportCardResolver = dashboardWidget.querySelector('[data-test-id="report-card-v2--resolver"]');
  if (!reportCardResolver) return {};
  const rect = reportCardResolver.getBoundingClientRect();
  if (!rect) return {};
  return {
    reportContainerWidth: Math.round(rect.width),
    reportContainerHeight: Math.round(rect.height)
  };
};
export const getDefaultReportPropertiesForUsageTracker = (report, trackingAssetType, trackingApplicationName, trackingScreenName, calculateContainerDimensions) => {
  let containerDimensions = {};
  if (calculateContainerDimensions) {
    const reportId = getReportId(report);
    if (reportId) {
      containerDimensions = getReportContainerDimensions(reportId);
    }
  }
  return Object.assign({
    chartType: getReportChartType(report),
    dataTypes: getReportDataTypesForTracking(report),
    assetType: trackingAssetType || 'report',
    applicationName: trackingApplicationName || 'unknown',
    whereScreen: trackingScreenName || 'unknown',
    isMultiAccount: isMultiAccountReport(report)
  }, getReportAndDashboardIds(report), containerDimensions);
};
export const getDefaultReportRenderProperties = (report, trackingAssetType, trackingApplicationName, trackingScreenName, calculateContainerDimensions) => {
  const defaultReportRenderProperties = Object.assign({}, getDefaultReportPropertiesForUsageTracker(report, trackingAssetType, trackingApplicationName, trackingScreenName, calculateContainerDimensions), {
    reportType: getReportType(report),
    templateKey: getTemplateKey(report),
    pluginName: getPluginName(report),
    customWidgetType: getCustomWidgetType(report)
  });
  if (isConfigReport(report)) {
    const configReportRenderProperties = {
      dimensions: getDimensions(report).toJS(),
      filters: stableStringify(getFiltersFromConfigReport(report)),
      metrics: stableStringify(getMetrics(report))
    };
    return Object.assign({}, defaultReportRenderProperties, configReportRenderProperties);
  }
  if (isRelationalReport(report)) {
    const relationalReportRenderProperties = {
      dimensions: getDimensionsFromRelationalReport(report).toJS(),
      filters: stableStringify(getFilteringFromRelationalReport(report).toJS()),
      metrics: stableStringify(getMetricPropertyAndAggregationFromRelationalReport(report).toJS())
    };
    return Object.assign({}, defaultReportRenderProperties, relationalReportRenderProperties);
  }
  return defaultReportRenderProperties;
};
export const getReportHoverUsageTrackerProperties = (report, trackingAssetType) => Object.assign({}, getDefaultReportPropertiesForUsageTracker(report, trackingAssetType), {
  action: 'hover-over',
  assetType: trackingAssetType || 'report',
  templateKey: getTemplateKey(report),
  origin: getOrigin(report),
  customWidgetType: getCustomWidgetType(report)
});
export const getClickTableCellLinkUsageTrackerProperties = (report, trackingProperties) => Object.assign({
  action: 'click-table-cell-link',
  assetType: 'report'
}, getReportAndDashboardIds(report), trackingProperties);
export const getHoverUsageTrackerPropertiesNonPlatformReport = reportIdentifier => ({
  action: 'hover-over',
  assetType: 'report',
  isNonPlatformReport: true,
  reportIdentifier
});
export const getOnTableCellLinkClickCallback = report => trackingProperties => {
  const usageTracker = getUsageTracker();
  usageTracker.track(EVENTS.clickTableCellLink, Object.assign({}, getClickTableCellLinkUsageTrackerProperties(report, trackingProperties)));
};
export const getReportDrillIntoUsageTrackerProperties = (report, trackingAssetType, trackingApplicationName, trackingScreenName) => Object.assign({}, getDefaultReportPropertiesForUsageTracker(report, trackingAssetType, trackingApplicationName, trackingScreenName), {
  action: DRILLDOWN_ACTION,
  templateKey: getTemplateKey(report)
});